/*globals com*/
import React, { useEffect } from 'react';
import AuthInitComponent from './components/AuthInitComponent';
import PropTypes from 'prop-types';
export default function TransmitWebSDKEnterpriseAuth(props) {
  const clearSession = () => {
    sessionStorage.removeItem('currentSession');
    localStorage.removeItem('users');
  };
  clearSession();
  let showAuth = true;
  const handleAuthResponse = response => {
    showAuth = false;
    let resultResponse = "";
    if ('_internalData' in response) {
      resultResponse = response._internalData.json_data;
    } else {
      resultResponse = response;
    }
    props.handleAuthResponse(resultResponse);
  };
  useEffect(() => {
    const abortController = new AbortController();
    return function cancel() {
      abortController.abort();
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, showAuth == true ? /*#__PURE__*/React.createElement(AuthInitComponent, {
    config: props.config,
    params: props.params,
    handleAuthResponse: handleAuthResponse
  }) : null);
}
TransmitWebSDKEnterpriseAuth.propTypes = {
  config: PropTypes.string.isRequired,
  handleAuthResponse: PropTypes.any.isRequired,
  params: PropTypes.object.isRequired
};